export class UserInfo {
    email: string
    name: string  // Public nickname
    firstName: string  // Private
    lastName: string   // Private
    isAdmin: boolean = false

    constructor(email: string, name: string, firstName: string = '', lastName: string = '') {
        this.email = email
        this.name = name
        this.firstName = firstName
        this.lastName = lastName
    }

    static getName(users: UserInfo[], email: string) {
        const match = users.find(u => u.email === email)
        if (match) return match.name
        return ''
    }

    static getUserByEmail(users: UserInfo[], email: string) {
        console.log('getUserByEmail', email, users)
        return users.find(u => u.email === email)
    }
}
